export default "__VITE_ASSET__DEQS8wzX__"